<template>
  <div class="analysis">
    <mu-form :model="form" label-width="80" inline>
      <mu-form-item label="开始日期">
        <mu-date-input container="dialog" v-model="form.startTime" />
      </mu-form-item>
      <mu-form-item label="结束日期">
        <mu-date-input container="dialog" v-model="form.endTime" />
      </mu-form-item>
      <mu-form-item class="search-btn">
        <mu-button color="primary" @click="getAll">
          <mu-icon left value="search" :size="20"></mu-icon>
          查看
        </mu-button>
      </mu-form-item>
    </mu-form>
    <mu-data-table
      :columns="columns"
      :data="list"
      class="table"
      :loading="loading"
    >
      <template slot-scope="scope">
        <td>{{ scope.row.month }}</td>
        <td>
          {{ numToMoney(scope.row.orderMoney) }}
        </td>
        <td>
          {{ numToMoney(scope.row.paymentMoney) }}
        </td>
        <td>
          {{ numToMoney(scope.row.outMoney) }}
        </td>
        <td :class="{ red: scope.row.profit < 0, green: scope.row.profit > 0 }">
          {{ numToMoney(scope.row.profit) }}
        </td>
        <td :class="{ red: scope.row.cash < 0, green: scope.row.cash > 0 }">
          {{ numToMoney(scope.row.cash) }}
        </td>
      </template>
    </mu-data-table>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
import numeral from 'numeral'
import moment from 'moment'
import { numToMoney } from '@/utils/string'
export default {
  data() {
    return {
      numToMoney,
      form: {
        startTime: '2019-01-01',
        endTime: moment()
          .endOf('month')
          .format('YYYY-MM-DD'),
        getAll: true
      },
      columns: [
        {
          title: '月份',
          align: 'center'
        },
        {
          title: '订单金额',
          align: 'center'
        },
        {
          title: '现金收入',
          align: 'center'
        },
        {
          title: '支出',
          align: 'center'
        },
        {
          title: '盈亏（订单金额-支出）',
          align: 'center'
        },
        {
          title: '现金（现金收入-支出）',
          align: 'center'
        }
      ],
      list: [],
      loading: false
    }
  },
  methods: {
    getAllOrder() {
      return new Promise(resolve => {
        backend(api.order.getAll, this.form).then(result => {
          if (result.statusCode === 200) {
            const list = []
            result.data.rows.forEach(item => {
              const exist = list.find(
                x => x.month === moment(item.createTime).format('YYYYMM')
              )
              if (exist) {
                exist.orders.push(item)
                exist.money.add(item.sum)
              } else {
                list.push({
                  month: moment(item.createTime).format('YYYYMM'),
                  orders: [item],
                  money: numeral(0).add(item.sum)
                })
              }
            })
            resolve(list)
          }
        })
      })
    },
    getAllPayment() {
      return new Promise(resolve => {
        backend(api.payment.getAll, this.form).then(result => {
          if (result.statusCode === 200) {
            const list = []
            result.data.rows.forEach(item => {
              const exist = list.find(
                x => x.month === moment(item.createTime).format('YYYYMM')
              )
              if (exist) {
                exist.payments.push(item)
                exist.money.add(item.money)
              } else {
                list.push({
                  month: moment(item.createTime).format('YYYYMM'),
                  payments: [item],
                  money: numeral(0).add(item.money)
                })
              }
            })
            resolve(list)
          }
        })
      })
    },
    getAllOut() {
      return new Promise(resolve => {
        backend(api.out.getAll, this.form).then(result => {
          if (result.statusCode === 200) {
            const list = []
            result.data.rows.forEach(item => {
              const exist = list.find(
                x => x.month === moment(item.createTime).format('YYYYMM')
              )
              if (exist) {
                exist.outs.push(item)
                exist.money.add(item.sum)
              } else {
                list.push({
                  month: moment(item.createTime).format('YYYYMM'),
                  outs: [item],
                  money: numeral(0).add(item.sum)
                })
              }
            })
            resolve(list)
          }
        })
      })
    },
    getAll() {
      this.loading = true
      const list = []
      Promise.all([
        this.getAllOrder(),
        this.getAllPayment(),
        this.getAllOut()
      ]).then(result => {
        this.loading = false
        const orderTotal = numeral(0)
        const paymentTotal = numeral(0)
        const outTotal = numeral(0)
        const profitTotal = numeral(0)
        const cashTotal = numeral(0)
        const startMonth = Number(moment(this.form.startTime).format('YYYYMM'))
        const endMonth = Number(moment(this.form.endTime).format('YYYYMM'))
        let month = startMonth
        while (month <= endMonth) {
          const monthStr = `${month}`
          const orderMoney = result[0].find(x => x.month === monthStr)
          const paymentMoney = result[1].find(x => x.month === monthStr)
          const outMoney = result[2].find(x => x.month === monthStr)
          const temp = {
            month,
            orderMoney: orderMoney ? orderMoney.money.value() : 0,
            paymentMoney: paymentMoney ? paymentMoney.money.value() : 0,
            outMoney: outMoney ? outMoney.money.value() : 0
          }
          temp.profit = numeral(temp.orderMoney)
            .subtract(temp.outMoney)
            .value()
          temp.cash = numeral(temp.paymentMoney)
            .subtract(temp.outMoney)
            .value()
          orderTotal.add(temp.orderMoney)
          paymentTotal.add(temp.paymentMoney)
          outTotal.add(temp.outMoney)
          profitTotal.add(temp.profit)
          cashTotal.add(temp.cash)
          list.push(temp)
          month = Number(
            moment(monthStr, 'YYYYMM')
              .add(1, 'month')
              .format('YYYYMM')
          )
        }

        list.push({
          month: '合计',
          orderMoney: orderTotal.value(),
          paymentMoney: paymentTotal.value(),
          outMoney: outTotal.value(),
          profit: profitTotal.value(),
          cash: cashTotal.value()
        })
        this.list = list
      })
    }
  },
  mounted() {
    this.getAll()
  }
}
</script>

<style lang="less" scoped>
.analysis {
  .table {
    td {
      text-align: center;

      &.green {
        color: green;
      }

      &.red {
        color: red;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/reporter/analysis.vue